import React from "react";
import { Icon, Label, Table, Header, Embed } from "semantic-ui-react";
import { GetUser } from "../../services/auth";
import TemplateMain from "../../components/TemplateMain";

const Videos: React.FC = () => {
    const { role } = GetUser();    
    const content = (  
        <>
        <Header icon="youtube play" as="h1" content="Vídeos" dividing/>     
        <Table
            fixed 
            selectable 
            color="pink">
            <Table.Body>
            {(role === "Admin" || role === "Operador")
            &&
                <Table.Row>
                    <Table.Cell width="3">
                        <Embed
                            active
                            id='pQApRRauW1g'
                            source='youtube'
                        />
                    </Table.Cell>
                    <Table.Cell width="3">
                            <h3>SEJA ESSE TIPO DE LÍDER</h3>
                            <p></p>
                            <p>Mesmo que tantos achem que o líder ideal é o que aparece mais e o que fala mais, nem sempre é o caso. 
                            Grandes líderes são os que melhor entendem a visão da organização e traduz isso em metas realizáveis pela equipe.</p>
                            <p></p>
                            <small>
                            <Label>
                                <Icon 
                                    name='youtube'
                                    color="red"
                                 />
                                PAULO VIEIRA - FEBRACIS
                            </Label>    
                            </small>   
                    </Table.Cell>               
                </Table.Row>}                      
            </Table.Body>
        </Table>
        </>
    )
    return (
        <TemplateMain
            loading={false}
            content={content}
        />
    )
}
export default Videos;